import { render } from "./RolesPage.vue?vue&type=template&id=fb7c4ec4&ts=true"
import script from "./RolesPage.vue?vue&type=script&lang=ts"
export * from "./RolesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Roles/RolesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb7c4ec4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb7c4ec4', __exports__)) {
    api.reload('fb7c4ec4', __exports__)
  }
  
  module.hot.accept("./RolesPage.vue?vue&type=template&id=fb7c4ec4&ts=true", () => {
    api.rerender('fb7c4ec4', render)
  })

}


export default __exports__